import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod/v4";

export const getShippingClaimUniqueValues = {
  name: "getShippingClaimUniqueValues" as const,
  input: AdvancedFilterInputSchema.extend({
    filterName: z.string(),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
